import React, { useEffect, useState } from "react";
import { Card, Modal, Row } from "react-bootstrap";
import LikertScale from "../../my-cases/my-case/assessments/LikertScale";

interface CustomState {
  showModal: boolean;
  setShowModal: any;
  assessment: any;
}

const AssessmentModal = ({ showModal, setShowModal, assessment }: CustomState) => {
  const [likertValues, setLikertValues] = useState<any[]>([]);

  useEffect(() => {
    const likertVals = assessment?.question?.map((q: any) => {
      return {
        key: q.key,
        value: null,
      };
    });

    if (likertVals) {
      setLikertValues(likertVals);
    }
  }, [assessment]);

  const handleClose = () => {
    setShowModal(false);
    setLikertValues([]);
  };

  return (
    <Modal show={showModal} onHide={handleClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>{assessment?.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="my-0 py-0"></Row>
        {assessment?.question?.map((q: any, index: number) => (
          <Card className="bg-light mb-3" key={index}>
            <Card.Body>
              <Row>
                <h5 className="pb-2 app-header-text">
                  <label className="app-orange-text">{index + 1 + "."}</label>
                  {" " + q.question}
                </h5>
              </Row>
              <LikertScale
                fields={q.fields}
                keyValue={likertValues[index]?.key}
                value={likertValues[index]?.value}
                setValues={setLikertValues}
                beginText=""
                endText=""
                readOnly={false}
              />
            </Card.Body>
          </Card>
        ))}
      </Modal.Body>
    </Modal>
  );
};

export default AssessmentModal;
